import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function AuthorStory() {
  return <section className="pt-4 pb-24 sm:pt-24 bg-warm-alt" data-id="element-31">
      <div className="max-w-4xl mx-auto px-6" data-id="element-32">
        <FadeIn className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-warm-accent/10" data-id="element-33">
          <div className="flex flex-col md:flex-row gap-10 items-center" data-id="element-34">
            <div className="w-48 h-48 md:w-64 md:h-64 flex-shrink-0 rounded-full overflow-hidden border-4 border-warm-bg shadow-inner" data-id="element-35">
              <img src="https://cdn.magicpatterns.com/uploads/u4EUaa4vEdAGZ2dxsjb7zk/D8DAC88F-2EE7-49E8-9441-05356A86A1C0.png" alt="Mujer frente al mar al amanecer recuperando su bienestar" className="w-full h-full object-cover" data-id="element-36" />
            </div>

            <div data-id="element-37">
              <h2 className="text-3xl font-heading text-warm-dark mb-6" data-id="element-38">
                Mi historia detrás de la guía
              </h2>
              <div className="space-y-4 text-warm-dark/80 leading-relaxed" data-id="element-39">
                <p data-id="element-40">
                  Durante años trabajé largas jornadas manejando. Mi carro era
                  prácticamente mi oficina.
                </p>
                <p data-id="element-41">
                  Pasaba horas sentada, muchas veces ignorando señales que mi
                  cuerpo intentaba darme.
                </p>
                <p data-id="element-42">Cuando apareció el dolor, pensé que era algo pasajero.</p>
                <p data-id="element-43">
                  Pero con el tiempo comenzó a afectar mi trabajo, mi movilidad
                  y mi tranquilidad.
                </p>
                <p data-id="element-44">
                  Lo más difícil no fue únicamente el dolor físico.{' '}
                  <strong data-id="element-45">Fue el miedo.</strong>
                </p>
                <p data-id="element-46">
                  Miedo a no volver a sentirme normal. Miedo a que mi vida
                  siguiera limitada. Miedo a no encontrar respuestas.
                </p>
                <p data-id="element-47">
                  Pasé meses buscando respuestas. Probé ejercicios, fui a
                  fisioterapia, recibí tratamientos, aprendí de profesionales y
                  también cometí errores por desesperación.
                </p>
                <p data-id="element-48">
                  Poco a poco entendí que la recuperación no ocurre de la noche
                  a la mañana.
                </p>
                <p data-id="element-49">
                  Descubrí que se construye paso a paso, aprendiendo a confiar
                  nuevamente en tu cuerpo.
                </p>
                <p data-id="element-50">
                  Por eso nació <strong data-id="element-51">Espalda Libre</strong>.
                </p>
                <p data-id="element-52">
                  Esta guía reúne las ideas, hábitos y aprendizajes que más me
                  ayudaron durante mi propio proceso de recuperación.
                </p>
                <p data-id="element-53">
                  Si hoy te sientes perdido, confundido o cansado de buscar
                  respuestas, espero que estas páginas puedan acompañarte como a
                  mí me habría gustado que alguien me acompañara.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}